import * as React from "react";
import { Link } from "react-router-dom";
import BPStore from "../../../../stores/BPStore";
import { GetBPList, ImportBP } from "../../../../actions/BPActions";
import actionTypes from "../../../../actions/ActionTypes";
import { PostAlert } from "../../../../actions/AlertActions";
class BPSidebar extends React.Component {
  constructor() {
    super();
    this.state = {
      bpList: [],
      searchText: "",
      filteredBPList: [],
      importBP: false,
      waitingOnImport: false,
      importResult: false,
      importMessage: "",
      importedBPName: "",
      allowImport: false,
      maxHeight: window.innerHeight - 280
    };
    this.onReceiveBPChange = this.onReceiveBPChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onClickImportBp = this.onClickImportBp.bind(this);
    this.closeImportBp = this.closeImportBp.bind(this);
    this.importNewBp = this.importNewBp.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.allowImportCheck = this.allowImportCheck.bind(this);
  }
  componentDidMount() {
    BPStore.addChangeListener(this.onReceiveBPChange);
    GetBPList();
  }
  componentWillUnmount() {
    BPStore.removeChangeListener(this.onReceiveBPChange);
  }
  onReceiveBPChange() {
    let lastChange = BPStore.getLastChange();
    if (lastChange === actionTypes.BPGetList) {
      let bps = BPStore.getBPList();
      this.setState({
        bpList: bps,
        searchText: "",
        filteredBPList: bps
      });
    }
    if (lastChange === actionTypes.ImportBP) {
      let importMessage = BPStore.getImportMessage();
      this.setState({ waitingOnImport: false, importResult: true, importMessage });
      GetBPList();
    }
  }
  onClickImportBp() {
    this.setState({ importBP: true });
  }
  closeImportBp() {
    this.setState({ importBP: false, importMessage: "" });
  }
  importNewBp() {
    new Response(document.getElementById("importBPfile").files[0]).json().then((json) => {
      this.setState({ waitingOnImport: true });
      ImportBP(this.state.importedBPName, JSON.stringify(json));
    }, (err) => {
      PostAlert("error", "Error! File uploaded is not correct json format");
    });
  }
  onChangeName(e) {
    this.setState({ importedBPName: e.target.value });
    this.allowImportCheck();
  }
  allowImportCheck() {
    if (this.state.importedBPName !== "" && document.getElementById("importBPfile").files.length > 0) {
      this.setState({ allowImport: true });
    } else {
      this.setState({ allowImport: false });
    }
  }
  onSearchChange(e) {
    let search = e.target.value;
    if (search === "") {
      let newList = [...this.state.bpList];
      this.setState({ searchText: search, filteredBPList: newList });
    } else {
      let newList = [];
      this.state.bpList.forEach((bp) => {
        if (bp.bpName.toLowerCase().includes(search.toLowerCase())) {
          newList.push(bp);
        }
      });
      this.setState({ searchText: search, filteredBPList: newList });
    }
  }
  render() {
    let listOfBPs;
    if (this.state.bpList !== null) {
      listOfBPs = this.state.filteredBPList.map((bp) => /* @__PURE__ */ React.createElement("div", { key: bp.bpId }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/BusinessProcess/" + bp.bpId,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        bp.bpName
      ), " "));
    } else {
      listOfBPs = /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "274px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/BusinessProcess",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("span", { style: { color: "#B023DD" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-th-large" })), "   ", "Business Processes")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { className: "input-group rounded", style: { marginBottom: "16px" } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "search",
          value: this.state.searchText,
          className: "form-control",
          placeholder: "Search",
          "aria-label": "Search",
          onChange: this.onSearchChange,
          "aria-describedby": "search-addon"
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "input-group-text border-0", id: "search-addon" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-search" }))),
      /* @__PURE__ */ React.createElement("div", { className: "coolScroll", style: { maxHeight: `${this.state.maxHeight}px`, overflowY: "auto" } }, listOfBPs),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/BusinessProcess/0" }, "New Business Process"),
      /* @__PURE__ */ React.createElement(Link, { onClick: this.onClickImportBp, className: "sidebar-link", to: "" }, "Import Business Process"),
      this.state.importBP && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement("div", { className: "td-dialogue card", style: { width: "450px" } }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Import new Business Process:", /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn-close",
          onClick: this.closeImportBp
        }
      )), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card-body",
          style: { height: "250px", overflow: "auto" }
        },
        this.state.waitingOnImport && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "fs-5" }, "Please wait while your new Business Process is being created..."), /* @__PURE__ */ React.createElement("div", { class: "fa-5x", style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-spinner fa-spin-pulse" }))),
        !this.state.waitingOnImport && /* @__PURE__ */ React.createElement("div", { className: "" }, this.state.importMessage !== "" && /* @__PURE__ */ React.createElement("div", { className: "pt-2" }, this.state.importMessage), this.state.importMessage === "" && /* @__PURE__ */ React.createElement("div", { className: "" }, /* @__PURE__ */ React.createElement("div", { className: "row mb-3" }, /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "col col-form-label",
            htmlFor: "txtUserName"
          },
          "Name:"
        ), /* @__PURE__ */ React.createElement("div", { className: "col-sm-10" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "txtUserName",
            value: this.state.importedBPName,
            onChange: this.onChangeName,
            placeholder: "New Business Process Name"
          }
        ))), /* @__PURE__ */ React.createElement("input", { id: "importBPfile", type: "file", onChange: this.allowImportCheck }), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: `btn btn-success ${this.state.allowImport ? "" : "disabled"}`,
            onClick: this.importNewBp
          },
          "Upload"
        )))
      )))
    );
  }
}
export default BPSidebar;
